import { computed } from 'vue';
import { normalizeLocale } from '@pendo/i18n';

export function normalizedLocale (locale) {
    return computed(() => normalizeLocale(locale?.value));
}